/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { PageResultContext } from '@squiz/dxp-ai-client';
import { PaginationPageLimit } from '@squiz/dxp-ai-types';
import { useObservable, UseObservableResult } from '@squiz/dxp-console-support';
import { useMemo } from 'react';
import { from } from 'rxjs';
import { getAiService } from '../GetAiService/getAiService';

export const useContexts = (
  aiId: string,
  pageSize: PaginationPageLimit,
  cursor?: string,
): UseObservableResult<PageResultContext | null> => {
  const aiService = getAiService();
  const contexts$ = useMemo(() => {
    return from(
      aiService.apiClient.chatbotContext.list({
        aiId,
        cursor: cursor ? parseInt(cursor) : undefined,
        pageSize,
      }),
    );
  }, [aiId, aiService, cursor, pageSize]);

  return useObservable(contexts$, [contexts$], undefined, true);
};
